export default "__VITE_ASSET__gxsz$fb6__"